import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const RootRedirect: React.FC = () => {
  const { isAuthenticated, user, isLoading } = useAuth();

  // Wait for auth to initialize
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Not authenticated → Login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Authenticated → Redirect based on role
  const role = user?.Role || user?.role;

  // Admin/Staff → Admin Dashboard
  if (role === 'Admin' || role === 3 || role === 'Staff' || role === 2) {
    return <Navigate to="/admin" replace />;
  }

  // Customer → Customer Dashboard
  return <Navigate to="/dashboard" replace />;
};

export default RootRedirect;
